import { ReactNode, useId, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type DisclosureProps = {
  label: string;
  children: ReactNode;
  /** Render the panel open on first load. Defaults to closed. */
  defaultOpen?: boolean;
};

/** Single accessible show/hide row used for secondary details. */
export function Disclosure({
  label,
  children,
  defaultOpen = false
}: DisclosureProps) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();
  return <div className="border-y border-ink/15" data-id="element-144" data-mp="2rdsm167jet6b">
      <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpen(value => !value)} className="flex min-h-[52px] w-full items-center justify-between gap-4 py-3 text-left text-[16.5px] font-semibold text-ink transition-colors duration-150 ease-out hover:text-pegasus-blue" data-id="element-145" data-mp="2reu9691tv64e">
        {label}
        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-pegasus-blue transition-transform duration-150 ease-out motion-reduce:transition-none ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-146" data-mp="28n1i4k6bjuzb" />
      </button>
      <div id={panelId} hidden={!open} className="pb-5" data-id="element-147" data-mp="32wg4d60mrjq2">
        {children}
      </div>
    </div>;
}